import type { Callout } from '@/lib/schemas/db'
import {
  calloutStatusTransitions,
  calloutStatusOrder,
  calloutStatusDescriptions,
  formatCalloutStatus,
} from '@/help/calloutStatusChanges'

import { withUniversalTransitions } from './statusRules'

export type CalloutStatus = Callout['status']

export { calloutStatusOrder, calloutStatusDescriptions, formatCalloutStatus }

/** Canonical order of callout statuses (drives transition ordering). */
export const CALLOUT_STATUS_ORDER: CalloutStatus[] = [
  'New',
  'Booked',
  'Arrived',
  'LeftSite',
  'Blocked',
  'Review',
  'ReadyToInvoice',
  'Invoiced',
  'Cancelled',
]

const statusTransitions: Partial<Record<CalloutStatus, CalloutStatus[]>> =
  calloutStatusTransitions

export function getAllowedCalloutStatusTransitions(
  currentStatus: CalloutStatus,
): CalloutStatus[] {
  return withUniversalTransitions(currentStatus, statusTransitions[currentStatus] ?? [], {
    order: CALLOUT_STATUS_ORDER,
    initial: 'New',
  })
}

export function assertCalloutStatusChangeAllowed(
  currentStatus: CalloutStatus,
  nextStatus: CalloutStatus,
) {
  const allowed = getAllowedCalloutStatusTransitions(currentStatus)
  if (!allowed.includes(nextStatus)) {
    throw new Error(
      `Cannot move Callout from ${currentStatus} to ${nextStatus}`,
    )
  }
}
